import React from "react";
import { useGetOnboardingStateQuery } from "@/store/rest_api";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const EXEMPT_PATHS = ["/onboarding", "/logout", "/manage-organisation/billing", "/payment-success", "/payment-failed"];

function isExempt(pathname: string): boolean {
  return EXEMPT_PATHS.some((path) => pathname === path || pathname.startsWith(path + "/"));
}

export default function OnboardingGate() {
  const location = useLocation();
  const { data, isLoading, isError } = useGetOnboardingStateQuery();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  if (isError) {
    return <Outlet />;
  }

  if (!data?.completed && !isExempt(location.pathname)) {
    return <Navigate to="/onboarding" replace />;
  }

  return <Outlet />;
}
